import { makeAutoObservable, runInAction } from 'mobx'
import dayjs from 'dayjs'
import { openApi } from '../../helpers/request'
import { OrdersDashboardData } from './orders-analytics.types'

class OrdersAnalyticsController {
    loading = false
    loaded = false
    error = ''
    data: OrdersDashboardData | null = null

    dateFrom = dayjs().subtract(29, 'day').format('YYYY-MM-DD')
    dateTo = dayjs().format('YYYY-MM-DD')
    deliveryType?: number = undefined
    source = ''
    placeId?: number = undefined
    warehouseId?: number = undefined
    paymentTypeId?: number = undefined

    constructor() {
        makeAutoObservable(this)
    }

    setDateRange(from: string, to: string) {
        this.dateFrom = from
        this.dateTo = to
        this.fetch()
    }

    setDeliveryType(value?: number) {
        this.deliveryType = value
        this.fetch()
    }

    setSource(value: string) {
        this.source = value
        this.fetch()
    }

    setPlaceId(value?: number) {
        this.placeId = value
        this.fetch()
    }

    setWarehouseId(value?: number) {
        this.warehouseId = value
        this.fetch()
    }

    setPaymentTypeId(value?: number) {
        this.paymentTypeId = value
        this.fetch()
    }

    fetch() {
        this.loading = true
        this.error = ''

        const params: string[] = [
            `from=${this.dateFrom}`,
            `to=${this.dateTo}`,
        ]
        if (this.deliveryType !== undefined) params.push(`delivery_type=${this.deliveryType}`)
        if (this.source) params.push(`source=${encodeURIComponent(this.source)}`)
        if (this.placeId !== undefined) params.push(`place_id=${this.placeId}`)
        if (this.warehouseId !== undefined) params.push(`warehouse_id=${this.warehouseId}`)
        if (this.paymentTypeId !== undefined) params.push(`payment_type_id=${this.paymentTypeId}`)

        openApi('get', `/analytics/orders-dashboard?${params.join('&')}`)
            .then((result: any) => {
                runInAction(() => {
                    this.data = (result?.data ?? null) as OrdersDashboardData | null
                    this.loading = false
                    this.loaded = true
                })
            })
            .catch((err: any) => {
                console.log(err)
                runInAction(() => {
                    this.loading = false
                    this.loaded = true
                    this.error = err?.response?.data?.error ?? 'failed to load'
                })
            })
    }
}

export default new OrdersAnalyticsController()
